import React from "react";

type TruckIconProps = React.SVGProps<SVGSVGElement> & { color?: string };

export const TruckIcon = ({ width = 24, height = 24, color = "#79808A", ...props }: TruckIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 6h12v9H3V6zM15 9h4l2 3v3h-6V9zM7 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM18.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default TruckIcon;
